$ = jQuery;

$(function()
{
    var $biscuits = $('.scroll-biscuit, .history__img'),
        $document = $(document);

    if ( $biscuits.length )
    {
        $document.on('scroll', function()
        {
            var scrolltop = $document.scrollTop();

            $biscuits.each(function(i, el) {
                $(el).css('transform', 'translateY(-'+(scrolltop/(parseInt(el.getAttribute('data-speed'))))+'px)');
            });
        });
    }

    $('.gallery').colcade({
        columns: '.gallery__col',
        items: '.gallery__item'
    });

    jQuery('.gallery__item').magnificPopup({
        type:'inline',
        midClick: true
    });
});


tippy('[data-tippy-content]');


// Radio.
var radio = document.getElementById('radio__file'),
    radioPlay = $('.radio__play'),
    radioStop = $('.radio__stop');

radioPlay.on('click', () => {radio.play(); radioPlay.hide(); radioStop.show();});
radioStop.on('click', () => {radio.pause(); radio.currentTime = 0; radioStop.hide(); radioPlay.show();});


// Registration company fields.
let $customerTypeField = $('[name=customer_type]'),
    $proFields = $('.is-pro-field');

$customerTypeField.on('change', function()
{
    $customerTypeField.filter(':checked').val() === 'entreprise' ? $proFields.show() : $proFields.hide();
});

$customerTypeField.trigger('change');


console.log(
    '            ████ ████ ███ \n'+
    '            █    █    █  █\n'+
    '            ████ ███  ███ \n'+
    '               █ █    █  █\n'+  
    '            ████ ████ ███ \n'+
    'http://sebastien.vignol.be'
);